import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTag } from "@fortawesome/free-solid-svg-icons";
import "./styles/HoverDropdown.css";

function HoverDropdown({
  downloadTxtFile,
  text,
  handleTitleChange,
  exportfeatures,
  handleTabChange,
  setSelectedWeights,
  handleExportTypeChange,
  handleSelection,
  feature,
  // "anchored" (default) keeps the existing small dropdown-menu anchored to
  // the trigger, used everywhere else this component appears. "modal" opts
  // into the shared popup-modal-* design (backdrop + centered panel) so
  // this dropdown looks consistent with the Export button popup, Global
  // Settings, and Question Settings popups in SurveyBuilder.
  variant = "anchored",
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isDropdownOpen || variant === "modal") return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownOpen, variant]);

  const toggle = () => setIsDropdownOpen((v) => !v);
  const close = () => setIsDropdownOpen(false);

  const onSelection = (value, displayText) => {
    if (feature === 1) {
      downloadTxtFile(value);
    } else if (feature === 2) {
      handleTabChange(value);
    } else if (feature === 3) {
      setSelectedWeights(value);
    } else if (feature === 4) {
      handleExportTypeChange(value);
    } else if (feature === 5) {
      handleTitleChange("type", displayText);
    } else if (feature === 6 && handleSelection) {
      handleSelection(displayText);
    }
    close();
  };

  // Single source of truth for the option list, independent of which
  // chrome (anchored dropdown vs. modal popup) renders it.
  const items = (() => {
    if (feature === 1) {
      return exportfeatures?.map((x, i) => ({ key: i, label: x.text, onClick: () => onSelection(x.type, x.text) })) || [];
    }
    if (feature === 2) {
      return exportfeatures?.map((x, i) => ({ key: i, label: x.name, onClick: () => onSelection(x.name, x.name) })) || [];
    }
    if (feature === 3) {
      return exportfeatures ? Object.keys(exportfeatures).map((x, i) => ({ key: i, label: x, onClick: () => onSelection(x, x) })) : [];
    }
    if (feature === 4) {
      return exportfeatures?.map((x, i) => ({ key: i, label: x.text, onClick: () => onSelection(x.value, x.text) })) || [];
    }
    if (feature === 5) {
      return exportfeatures?.map((x, i) => ({ key: i, label: x.text, onClick: () => onSelection(x.text, x.text) })) || [];
    }
    if (feature === 6) {
      return exportfeatures?.map((f, i) => ({ key: i, label: f.label || f.value, onClick: () => handleSelection(f.value) })) || [];
    }
    return [];
  })();

  return (
    <div ref={containerRef} className="hover-dropdown">
      <span
        className={`hover-text${isDropdownOpen ? " hover-text--active" : ""}`}
        onClick={toggle}
      >
        {text}
      </span>

      {isDropdownOpen && variant === "modal" && (
        <div className="popup-modal-backdrop" onClick={close}>
          <div className="popup-modal-panel" onClick={(e) => e.stopPropagation()}>
            <div className="popup-modal-header">
              <div className="popup-modal-header-left">
                <FontAwesomeIcon icon={faTag} className="popup-modal-icon" />
                <span className="popup-modal-title">{text}</span>
              </div>
              <button className="popup-modal-close-btn" onClick={close} title="Close">
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="popup-modal-body">
              {/* Feature 6 (list selection) has rich, wide row content
                  (name + usage badges) - a single stacked column reads
                  better than the short-label grid used for e.g. Type
                  Selection. */}
              <div className={feature === 6 ? "popup-modal-list" : "popup-modal-grid"}>
                {items.map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    className="popup-modal-option-btn"
                    onClick={item.onClick}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {isDropdownOpen && variant !== "modal" && (
        <div className="dropdown-menu">
          <div className="hover-dropdown-header">
            <div className="hover-dropdown-header-left">
              <FontAwesomeIcon icon={faTag} className="hover-dropdown-icon" />
              <span className="hover-dropdown-title">{text}</span>
            </div>
            <div className="hover-dropdown-header-right">
              <button className="hover-dropdown-close" onClick={close} title="Close">
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          {items.map((item) => (
            <div key={item.key} className="dropdown-item" onClick={item.onClick}>
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default HoverDropdown;
